import Price from '~/utils/Price/Price';
import { ProductPrice } from '~/Product';

import ProductComputedPrice from './ProductComputedPrice';
import ReferencePrice from './ReferencePrice';

export interface RawReferencePrice {
	calculatedPrice: {
		currency: string;
		description: string;
		type: string;
		value: string;
		selected: boolean;
	};
	sourcePrice: { currency: string; type: string; value: string };
}

export const mapReferencePrice = (referencePrice: RawReferencePrice): ReferencePrice => {
	return new ReferencePrice(
		new ProductPrice(
			referencePrice.sourcePrice.type,
			new Price(referencePrice.sourcePrice.value, referencePrice.sourcePrice.currency),
			0
		),
		new ProductComputedPrice(
			referencePrice.calculatedPrice.type,
			new Price(referencePrice.calculatedPrice.value, referencePrice.calculatedPrice.currency),
			referencePrice.calculatedPrice.description,
			referencePrice.calculatedPrice.selected
		)
	);
};
